import axios from '../axios';

const deleteProjectMedia = async (projectId: string, mediaId: string) => {
  const { data } = await axios.delete(`/media/${projectId}/${mediaId}`);

  return data;
};

export default deleteProjectMedia;
